/** 261104 E1-P1 — màn «Máy chuẩn bị» (prepare-running · tạm dừng · prepare-error · hết trần tiền) và màn «bốn quyết định đã chốt» (GATES_DONE, chỉ đọc). */
import React from 'react';
import type { SkillGate, SkillRunProjection } from '../../../types/skillAdaptation';
import { SKILL_GATES } from '../../../types/skillAdaptation';
import { GATE_TITLE, prepareCopyOf } from './skillAdaptUtils';
import { gatesDoneCopyOf } from './skillWritingUtils';

export interface PrepareProps { run: SkillRunProjection; stateId: string; busy: boolean; onPause: () => void; onResume: () => void; onRaiseCap: () => void }

export const SkillPrepareScreen: React.FC<PrepareProps> = ({ run, stateId, busy, onPause, onResume, onRaiseCap }) => {
  const copy = prepareCopyOf(run, stateId);
  const p = run.progress; const pct = p?.total ? Math.max(4, Math.round(((p.done ?? 0) / p.total) * 100)) : 8;
  const nextName = run.approvedGates.length < SKILL_GATES.length ? GATE_TITLE[SKILL_GATES[run.approvedGates.length]] : '';
  const onPrimary = copy.primaryButton === 'raise-cap' ? onRaiseCap : copy.primaryButton === 'resume' ? onResume : onPause;
  return (
    <div className="panel run">
      {copy.badge ? <span className={`chip ${copy.badgeTone ?? ''}`}>{copy.badge}</span> : <span className="spin" aria-label="Đang chạy" />}
      <h2>{copy.headline}</h2>
      <p className="muted">{copy.body}</p>
      {p ? <p>{p.label}</p> : null}
      <div className="progress"><span style={{ width: `${pct}%` }} /></div>
      {nextName ? <span className="chip blue">Tiếp theo: {nextName}</span> : null}
      <p className="note">Cập nhật gần nhất: {new Date(run.modifiedAt).toLocaleTimeString('vi-VN')}</p>
      {copy.badgeTone === 'bad' && run.lastError ? <details className="fd"><summary>Xem chi tiết</summary><p className="muted">{run.lastError.message}</p></details> : null}
      {copy.moneyLine ? <div className="budget"><span className="chip warn">{copy.moneyLine}</span></div> : null}
      <div className="row" style={{ justifyContent: 'center', marginTop: 20 }}>
        {copy.primaryButton === 'pause'
          ? <button type="button" className="btn" disabled={busy || run.pauseRequested} onClick={onPrimary}>{run.pauseRequested ? 'Sẽ dừng sau bước đang chạy…' : copy.primaryLabel}</button>
          : <button type="button" className="btn primary" disabled={busy || copy.primaryDisabled} onClick={onPrimary}>{copy.primaryLabel}</button>}
      </div>
    </div>
  );
};

/** Lượt cũ đã chốt bốn quyết định (GATES_DONE): nút «Viết kịch bản» (C7) kèm ước tiền; vẫn xem lại được từng cổng. */
export const SkillGatesDone: React.FC<{ run: SkillRunProjection; busy: boolean; onView: (g: SkillGate) => void; onWrite: () => void }> = ({ run, busy, onView, onWrite }) => {
  const copy = gatesDoneCopyOf(run);
  return (
    <div className="panel run gatedone" data-testid="gates-done">
      <div className="tick">✓</div>
      <h2>{copy.headline}</h2>
      <p className="muted">{copy.body}</p>
      <div className="row" style={{ justifyContent: 'center' }}>
        <button type="button" className="btn primary" data-testid="write-script" disabled={busy} onClick={onWrite}>{copy.writeLabel}</button>
        <span className="chip" data-testid="write-cost">{copy.costLine}</span>
      </div>
      <div className="row">{SKILL_GATES.map((g) => <button key={g} type="button" className="btn" onClick={() => onView(g)}>Xem {GATE_TITLE[g]}</button>)}</div>
      <p className="note">{copy.note}</p>
    </div>
  );
};
